
import { useContext, useEffect } from 'react';

import { isProduction } from '@/appConfig';
import { Subdomain, User } from '@/core/api/collections/currentAccount';
import { AuthContext } from '@/core/auth/AuthContext';
import initFullstory from '@/fullstory.config';

export default function Analytics() {
  const { currentUser, currentSubdomain } = useContext(AuthContext);

  useEffect(() => {
    if (isProduction()) {

      if (!window.FullStory) {
        initFullstory();
      }
    }
  }, []);

  useEffect(() => {
    if (isProduction() && currentUser && currentSubdomain) {
      initHeap();
      identify(currentUser, currentSubdomain);
    }
  }, [currentUser, currentSubdomain]);


  return null;
}

// Ignore typings for window in this file:
declare var window: any;

function identify(user: User, subdomain: Subdomain) {
  // Check user.id to verify that we're signed in
  if (!user?.id || !subdomain) { return; }

  // Without FULLSTORY_ORG, FullStory is not initialized
  if (window.FullStory) {
    window.FullStory.identify(user.id.toString(), {
      displayName: user.displayName,
      email: user.email,
      accountName_str: subdomain.key,
    });
  }
};

let heapAnalyticsScript: HTMLScriptElement;
function initHeap() {
  if (heapAnalyticsScript) { return; }
  heapAnalyticsScript = document.createElement('script');
  heapAnalyticsScript.setAttribute('src', '/analytics/heap.js');
  document.head.appendChild(heapAnalyticsScript);
}
